import React, { useContext, useEffect, useRef, useState } from "react";
import "./Pnav.css";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { House, User, MessageCircleHeart, CopyCheck } from "lucide-react";
import NoteContext from "../../Context/NikhaContext";

const Pnav = () => {
  const {
    allConnected,
    getAllConnected,
  } = useContext(NoteContext);
  const navigate = useNavigate();
  const location = useLocation();
  const [highlightProps, setHighlightProps] = useState({
    left: -9999,
    width: 0,
  });
  const navRefs = useRef([]);
  const [tail, setTail] = useState(null);

  useEffect(() => {
    const links = ["/app/", "/app/matches", "/app/chats", "/app/profile"];

    const current = navRefs.current.find(
      (ref) => ref && ref.dataset.path === location.pathname
    );

    if (links.includes(location.pathname) && current) {
      const oldLeft = highlightProps.left + highlightProps.width / 2;
      const newLeft = current.offsetLeft + current.offsetWidth / 2;

      if (oldLeft !== newLeft) {
        setTail({ from: oldLeft, to: newLeft });
      }

      setHighlightProps({
        left: current.offsetLeft,
        width: "50px",
      });
    } else {
      // Hide highlight if route doesn't match any nav item
      setHighlightProps({ left: -9999, width: 0 });
    }
  }, [location]);

  useEffect(() => {
    if (tail) {
      const timeout = setTimeout(() => {
        setTail(null);
      }, 500);
      return () => clearTimeout(timeout);
    }
  }, [tail]);

  return (
    <div className="Pnav">
      <ul>
        <li>
          <NavLink
            to={"/app/"}
            className="nav-link"
            data-path={"/app/"}
            ref={(el) => (navRefs.current[0] = el)}
          >
            <House />
          </NavLink>
        </li>
        <li>
          <NavLink
            to={"/app/matches"}
            className="nav-link"
            data-path={"/app/matches"}
            ref={(el) => (navRefs.current[1] = el)}
          >
            <CopyCheck />
          </NavLink>
        </li>
        <li>
          <NavLink
            to={"/app/chats"}
            className="nav-link"
            data-path={"/app/chats"}
            ref={(el) => (navRefs.current[2] = el)}
          >
            <MessageCircleHeart />
          </NavLink>
        </li>
        <li>
          <NavLink
            to={"/app/profile"}
            className="nav-link"
            data-path={"/app/profile"}
            ref={(el) => (navRefs.current[3] = el)}
          >
            <User />
          </NavLink>
        </li>
      </ul>
    </div>
  );
};

export default Pnav;
